import { AdmService } from 'src/app/shared/services/adm.service';
import { Compania } from 'src/app/shared/models/compania';
import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { defaultValueOrRangeValidator, isMobile, isMobileXL, loadData, toFormData } from 'src/app/shared/utils/helpers';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { ListaPrecioCabecera } from 'src/app/shared/models/listaPrecioCabecera';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Moneda } from 'src/app/shared/models/moneda';
import { Pais } from 'src/app/shared/models/pais';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { TerminoPago } from 'src/app/shared/models/terminoPago';
import { PedidoVentaItem } from 'src/app/shared/models/pedidoVentaItem';
import { ParametrosService } from 'src/app/shared/services/parametros.service';
import { PVService } from 'src/app/shared/services/pv.service';
import { PedidoVentaCabecera } from 'src/app/shared/models/pedidoVentaCabecera';
import { CuotaDistribuidor } from 'src/app/shared/models/cuotaDistribuidor';

@Component({
  selector: 'app-pva-item-dialog',
  templateUrl: './pva-item-dialog.component.html'
})
export class PVAItemDialogComponent {

  mensaje: number = 0;
  pvaItemForm: FormGroup;
  idTipo: number;
  lp: ListaPrecioCabecera;
  item: PedidoVentaItem;
  codigoEdit: number = -1;
  cantidadDisponible = new FormControl(0);
  etiquetaStockDisponible: string = "";
  precioFijo: boolean = false;
  pvaCab: PedidoVentaCabecera;
  cuotaDistribuidorSeleccionada: CuotaDistribuidor;
  cuotasDistribuidor: CuotaDistribuidor[] = [];
  avisoUnidadesPallet: boolean = false;
  mensajeUnidadesPallet: string;
  minDateFechaEntrega: Date
  constructor(
    private admService: AdmService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private configService: ConfigService,
    private loggedService: LoggedService,
    private dialogRef: MatDialogRef<PVAItemDialogComponent>,
    private parametrosService: ParametrosService,
    private productosService: ProductosService,
    private pvService: PVService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {

    this.pvaItemForm = this.fb.group({

      autor: [''],
      cantidad: [1, [Validators.max(this.cantidadDisponible.value)]],
      cultivo: [''],
      descuentoCategoria: [0],
      descuentoDiscrecional: [0],
      fechaCreacion: [new Date()],
      habilitacion: [true],
      idCompania: [''],
      idCultivo: [''],
      idDivision: [''],
      idLote: [''],
      idPais: [''],
      idPlanta: [''],
      idProducto: ['', Validators.required],
      idSalesOrg: [''],
      idTipoOrden: ['11'],
      nroLinea: [0],
      nroPedido: [0],
      porcentajeRecargo: [0],
      precioFinal: [0],
      precioKGL: [0],
      precioUnitarioFinal: [0],
      precioUnitarioLista: [0],
      producto: ['', Validators.required],
      recargo: [0],
      recargoLocal: [0],
      tipoOrden: ['Pedido Venta Anticipada'],
      total: [0],
      totalDescuento: [0],
      totalLocal: [0],
      totalPrecioKGL: [0],
      cuotaDistribuidorMesyAnio: ['', Validators.required],
      unidadesPallet: [0],
      fechaEntrega: [],
      codigo: [0]
    })

    if (data.cab != null) {
      this.pvaCab = data.cab;
    }

  }

  public Validaciones: {
    Cantidad: string,
    PrecioFinal: string
    FechaEntrega: string
  }

  public Etiquetas: {

    Cantidad: string,
    CantidadDisponible: string,
    IdProducto: string,
    Producto: string,
    PrecioUnitarioLista: string,
    PrecioUnitarioFinal: string,
    NroLinea: string,
    PrecioFinal: string,
    PrecioKGL: string
    CuotaDistribuidor: string
    FechaEntrega: string

  }

  ngOnInit() {
    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.mensaje));
    this.Validaciones = {
      Cantidad: this.configService.validaciones.Cantidad,
      PrecioFinal: this.configService.validaciones.PrecioFinal,
      FechaEntrega: this.configService.validaciones.FechaEntrega,
    }

    this.Etiquetas = {
      PrecioFinal: this.configService.etiquetas.PrecioFinal,
      Cantidad: this.configService.etiquetas.Cantidad,
      CantidadDisponible: this.configService.etiquetas.CantidadDisponible,
      PrecioKGL: this.configService.etiquetas.PrecioKGL,
      PrecioUnitarioFinal: this.configService.etiquetas.PrecioUnitarioFinal,
      PrecioUnitarioLista: this.configService.etiquetas.PrecioUnitarioLista,
      Producto: this.configService.etiquetas.Producto,
      NroLinea: this.configService.etiquetas.NroLinea,
      IdProducto: this.configService.etiquetas.IdProducto,
      CuotaDistribuidor: this.configService.etiquetas.CuotaDistribuidor,
      FechaEntrega: this.configService.etiquetas.FechaEntrega,
    }

    
    if (this.pvaCab != null) {
      if (this.pvaCab.items.length) {
        loadData(this.pvaItemForm, this.pvaCab.items[0]);
        this.codigoEdit = this.pvaCab.items[0].codigo;
        this.cantidadDisponible.valueChanges.subscribe(() => {
          this.pvaItemForm.controls['cantidad'].setValidators([Validators.required, Validators.min(0.001), Validators.max(this.cantidadDisponible.value)]);
          this.pvaItemForm.controls['cantidad'].updateValueAndValidity();
          this.pvaItemForm.controls['cantidad'].markAsTouched();
          this.pvaItemForm.controls['precioFinal'].setValidators([Validators.min(1), Validators.max(this.pvaItemForm.controls['precioUnitarioFinal'].value)]);
          this.pvaItemForm.controls['precioUnitarioFinal'].updateValueAndValidity();
          this.pvaItemForm.controls['precioUnitarioFinal'].markAsTouched();
        })

        this.pvService.cPedidoVentaItem(this.pvaCab.nroClienteDistribuidor, this.pvaCab.idSucursal, this.codigoEdit).subscribe((data: PedidoVentaItem) => {

          if (data != null) {
            this.pvaItemForm.controls['cantidad'].setValue(data.cantidad);
            this.pvaItemForm.controls['idProducto'].setValue(data.idProducto);
            this.pvaItemForm.controls['nroLinea'].setValue(data.nroLinea);
            this.pvaItemForm.controls['precioFinal'].setValue(data.precioUnitarioFinal);
            this.pvaItemForm.controls['precioKGL'].setValue(data.precioKGL);
            this.pvaItemForm.controls['precioUnitarioFinal'].setValue(data.precioUnitarioFinal);
            this.pvaItemForm.controls['precioUnitarioLista'].setValue(data.precioUnitarioLista);
            this.pvaItemForm.controls['producto'].setValue(data.producto);
            this.pvaItemForm.controls['unidadesPallet'].setValue(data.unidadesPallet);
            //   this.cantidadDisponible.setValue(data.cantidadDisponible);
            //   if (this.pvaCab.sucursal != null) {
            //     this.etiquetaStockDisponible = this.configService.etiquetas.CantidadDisponible + " (Sucursal " + this.pvaCab.sucursal + ")";
            //   }
          }

        });
      }

    }
    this.pvService.cCuotasDistribuidores(this.pvaCab.idPais, this.pvaCab.idCompania, this.pvaCab.idSalesOrg, this.pvaCab.nroClienteDistribuidor, this.pvaCab.idSucursal, this.pvaItemForm.controls['idProducto'].value).subscribe((data: CuotaDistribuidor[]) => {
      if (data != null) {

        this.cuotasDistribuidor = data;

        this.cuotaDistribuidorSeleccionada = this.cuotasDistribuidor.find(c => c.mesyAnio == this.pvaItemForm.controls['cuotaDistribuidorMesyAnio'].value);
        if (this.cuotaDistribuidorSeleccionada != null) {
          this.cantidadDisponible.setValue(this.cuotaDistribuidorSeleccionada.cantidadDisponibleVenta);
          this.pvaItemForm.controls['cuotaDistribuidorMesyAnio'].setValue(this.cuotaDistribuidorSeleccionada.mesyAnio);
           this.updateDateRange(this.cuotaDistribuidorSeleccionada.mesyAnio);
          this.pvaItemForm.controls['cantidad'].clearValidators();
          this.pvaItemForm.controls['cantidad'].setValidators([Validators.min(0.001), Validators.max(this.cuotaDistribuidorSeleccionada.cantidadDisponibleVenta)]);
          this.pvaItemForm.controls['cantidad'].updateValueAndValidity();

        }

      }
    });

  }

  guardarItem() {
    if (this.pvaItemForm.controls['unidadesPallet'].value == 0) {
      this.avisoUnidadesPallet = true
      this.mensajeUnidadesPallet = "No existen Kg/Litros para el producto"
    }
    else {

      const cantidadNum = this.pvaItemForm.controls['cantidad'].value;
      const unidadesPallet = this.pvaItemForm.controls['unidadesPallet'].value
      var esMultiplo =  Math.abs(cantidadNum / unidadesPallet - Math.round(cantidadNum / unidadesPallet)) < 1e-10;
      let valornum = cantidadNum / unidadesPallet

      if (!esMultiplo) {
        this.avisoUnidadesPallet = true;
        valornum = Math.floor(valornum) + 1
this.mensajeUnidadesPallet = "La cantidad no corresponde a los Kg/Litros (" + unidadesPallet.toString() + "), cantidad sugerida: "
          + parseFloat((unidadesPallet * (valornum - 1)).toFixed(3)).toString() + " ó " 
          + parseFloat((unidadesPallet * valornum).toFixed(3)).toString();
      } else {
        this.avisoUnidadesPallet = false;
      }
    }
    if (!this.avisoUnidadesPallet) {
      this.pvaCab.items = [];
      this.pvaCab.items.push(this.pvaItemForm.value);

      this.pvService
        .mPedidoVentaItem(this.pvaCab)
        .subscribe((data: boolean) => {
          this.mensaje = 2;
          this.dialogRef.close();
        });
    }

  }

  checkPrecioFinal() {
    if (this.pvaItemForm.controls['precioFinal'].value == null || (this.pvaItemForm.controls['precioFinal'].value != null && this.pvaItemForm.controls['precioFinal'].value == '')) {
      this.pvaItemForm.controls['precioFinal'].setValue(0);
    }
  }

  updateDateRange(date: string) {
    const [monthStr, yearStr] = date.split('-');
    const month = parseInt(monthStr, 10) - 1; // restamos 1 porque los meses en JS van de 0 a 11
    const year = parseInt(yearStr, 10);

    this.minDateFechaEntrega = new Date(year, month, 1);

  }
  seleccionarCuotaDistribuidor(cd: any) {

    this.cuotaDistribuidorSeleccionada = null;
    if (cd != null) {
      this.cuotaDistribuidorSeleccionada = this.cuotasDistribuidor.find(c => c.mesyAnio == cd);
      if (this.cuotaDistribuidorSeleccionada != null) {
        this.updateDateRange(this.cuotaDistribuidorSeleccionada.mesyAnio);
        this.pvaItemForm.controls['cuotaDistribuidorMesyAnio'].setValue(this.cuotaDistribuidorSeleccionada.mesyAnio);
        this.cantidadDisponible.setValue(this.cuotaDistribuidorSeleccionada.cantidadDisponibleVenta);
        // this.pvaItemForm.controls['cantidad'].setValue(0);
        this.pvaItemForm.controls['cantidad'].clearValidators();
        this.pvaItemForm.controls['cantidad'].setValidators([Validators.min(0.001), Validators.max(this.cuotaDistribuidorSeleccionada.cantidadDisponibleVenta)]);
        this.pvaItemForm.controls['cantidad'].updateValueAndValidity();

      }
    }
    else {
      this.pvaItemForm.controls['cuotaDistribuidorMesyAnio'].reset();
      this.pvaItemForm.controls['fechaEntrega'].setValue(null);
      this.cantidadDisponible.reset();
    }

  }

  compareCuotasDistribuidor(cdLista: any, cdPVA: any): boolean {
    return cdLista == cdPVA;
  }
  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }

}
